/*
*
* Navigation Actions
*
*/
import { GETrequest, POSTrequest } from 'utils/helpers/api_handler';

import {
  ALL_DATA_GET,
  ERROR_LOG,
} from './constants';

// TODO: api not working yet

export function getAllData() {
  const response = GETrequest('/alldata');
  return {
    type: ALL_DATA_GET,
    payload: response
  };
}

////////////////////////////////// ERROR LOG //////////////////////////////////
export function errorLog(body) {
  const response = POSTrequest('/error', body);
  return {
    type: ERROR_LOG,
    payload: response
  };
}